import Logo from '../_media/branding/logo.svg'
import AppBarTemplate from "../_shoru_shared_library/template/AppBarTemplate";

function AppBar(props) {

  console.log(props);

  return (
    <AppBarTemplate
      title='CastingBot'
      subtitle='shoru'
      logo={Logo}
      userData={props.userData}
      projectData={props.projectData}
      showAppsIcon={false}
      setOrganisationDialogOpen={props.setOrganisationDialogOpen}
      setProjectDialogOpen={props.setProjectDialogOpen}
      setSettingsOpen={props.setSettingsOpen}
    />
  )

}

export default AppBar;